<template>
	<transition name="slide-down">
		<div class="pagination" v-if="total > 1" ref="container">
			<ul>
				<li @click="page = 1" :class="{disabled: page <= 1}" ref="sizer"><icon icon="arrows/chevron/double-chevron-left-mini"></icon></li>
				<li @click="(page > 1) ? page-- : null" :class="{disabled: page <= 1}"><icon icon="arrows/chevron/chevron-left-mini"></icon></li>
				<li v-for="(p, index) in available" @click="page = p" :class="{active: page == p}">{{ p }}</li>
				<li @click="(page < total) ? page++ : null" :class="{disabled: page >= total}"><icon icon="arrows/chevron/chevron-right-mini"></icon></li>
				<li @click="page = total" :class="{disabled: page >= total}"><icon icon="arrows/chevron/double-chevron-right-mini"></icon></li>
			</ul>
		</div>
	</transition>
</template>

<script>
	export default {
		props: ['value', 'total'],
		data() {
			return {
				page: this.value,
				max: 0
			};
		},
		methods: {
			handleResize() {
				if(this.$refs.container){
					var width = this.$refs.container.getBoundingClientRect().width;
					var sizer = this.$refs.sizer.getBoundingClientRect();
					var left = parseInt(window.getComputedStyle(this.$refs.sizer).getPropertyValue('margin-left').match(/\d+/)[0]);
					var right = parseInt(window.getComputedStyle(this.$refs.sizer).getPropertyValue('margin-right').match(/\d+/)[0]);
					var size = left + right + sizer.width
					var max = Math.floor(width/size) - 4;
					this.max = max;
				}
			}
		},
		computed: {
			available() {
				let pages = [];
				if(this.total > this.max){
					var start = this.page - Math.floor(this.max / 2);
					if(start < 0){
						start = 0;
					}
					var end = start + this.max;
					if(end > this.total){
						end = this.total;
						start = this.total - this.max;
					}
					for(var i = start; i < end; i++){
						pages.push(i+1);
					}
				} else {
					for(var i = 0; i < this.total; i++){
						pages.push(i+1);
					}
				}
				return pages;
			}
		},
		watch: {
			page() {
				this.$emit('input', this.page);
			},
			value() {
				this.page = this.value;
			},
			total() {
				var self = this;
				self.$nextTick(() => {
					self.handleResize();
				});
			}
		},
		created() {
			window.addEventListener('resize', this.handleResize);
		},
		destroyed() {
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
			var self = this;
			self.$nextTick(() => {
				self.handleResize();
			});
		}
	}
</script>